var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"br-row-wrapper"},[_c('h1',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"content",attrs:{"ar":_vm.$i18n.locale === 'ar'}},[(_vm.child === 'uploder')?_c('Uploder',_vm._g(_vm._b({},'Uploder',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }